var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoSmall = function SvgLogoSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.964 17.732c-2.1-.017-3.79-1.683-3.773-3.723.018-2.039 1.735-3.678 3.836-3.661 2.101.016 3.79 1.683 3.773 3.722-.017 2.04-1.735 3.679-3.836 3.662Zm8.232-3.698c.103-1.96-.59-5.17-2.285-7.794-.045-.068-.121-.041-.105.03.113.4.14 1.123-.515 1.08-1.16-.075.04-2.486-2.508-4.158-.051-.034-.112.011-.084.064.174.323.278 1.328-.126 1.671-.324.275-.918.201-1.49-.704-.953-1.51-.591-3.123.056-4.13.049-.076-.018-.106-.073-.088-3.507 1.123-4.207 5.134-4.953 6.597-.125.245-.234.373-.448.36-.638-.042-.178-1.365.043-1.825.031-.065-.046-.1-.087-.059-1.805 1.831-3.44 4.949-3.75 7.846.01-.069-.029.24-.048.465a9.809 9.809 0 0 0-.03.585C.757 18.37 4.4 21.964 8.929 22c4.53.036 8.232-3.498 8.27-7.895l-.002-.071Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/logo-small.svg";